export default __webpack_public_path__ + "static/media/kitchen3-before1-480w.4bb20e05.avif";